import React from "react";
import withShipment from "../../../withShipment";
import {stateAndProvinceMappingSelector} from "../../../redux/selectors/global";
import {FTL_PAGES} from "../constants";
import FullTruckloadSetup from "./FullTruckloadSetup";
import FullTruckloadAddBroker from "./FullTruckloadBrokersForm";
import FullTruckLoadBrokers from "./FullTruckloadBrokers";
import FullTruckloadSignatures from "./FullTruckloadSignatures";
import FullTruckloadPOEs from "./FullTruckloadPOEs";

class FullTruckLoadSetting extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: FTL_PAGES.SETUP, //options are setup, signature, brokers
        }
    }

    handleTabChange = (selectedTab) =>{
        const tabLabels = [FTL_PAGES.SETUP, FTL_PAGES.CUSTOMS_BROKERS, FTL_PAGES.SIGNATURES, FTL_PAGES.NOA_PORTS];
        switch (tabLabels[selectedTab]) {
            case FTL_PAGES.SETUP:
                this.setState({
                    selectedTab: FTL_PAGES.SETUP
                })
                break;
            case FTL_PAGES.CUSTOMS_BROKERS:
                this.setState({
                    selectedTab: FTL_PAGES.CUSTOMS_BROKERS
                })
                break;
            case FTL_PAGES.SIGNATURES:
                this.setState({
                    selectedTab: FTL_PAGES.SIGNATURES
                })
                break;
            case FTL_PAGES.NOA_PORTS:
                this.setState({
                    selectedTab: FTL_PAGES.NOA_PORTS
                })
                break;
            default:
                this.setState({
                    selectedTab: FTL_PAGES.SETUP
                })
        }
    }

    tabLabelToTabIndex = (label) =>{
        switch (label) {
            case FTL_PAGES.SETUP:
                return 0
            case FTL_PAGES.CUSTOMS_BROKERS:
                return 1
            case FTL_PAGES.SIGNATURES:
                return 2
            case FTL_PAGES.NOA_PORTS:
                return 3
            default:
                return 0
        }
    }

    displaySetup = () => {
        return <React.Fragment>
            <FullTruckloadSetup
                selectedTab={this.tabLabelToTabIndex(this.state.selectedTab)}
                handleTabChange={this.handleTabChange}
                previewFullTruckloadFile={this.props.previewFullTruckloadFile}
                prevPage={this.props.prevPage}
                setCurrentPage={this.props.setCurrentPage}
            />
        </React.Fragment>
    }

    displayBrokers = () =>{
        return <React.Fragment>
            <FullTruckLoadBrokers
                selectedTab={this.tabLabelToTabIndex(this.state.selectedTab)}
                handleTabChange={this.handleTabChange}
                setCurrentPage={this.props.setCurrentPage}
                prevPage={this.state.prevPage}
            />
        </React.Fragment>
    }

    displaySignatures = () => {
        return <React.Fragment>
            <FullTruckloadSignatures
                selectedTab={this.tabLabelToTabIndex(this.state.selectedTab)}
                handleTabChange={this.handleTabChange}
                setCurrentPage={this.props.setCurrentPage}
                prevPage={this.state.prevPage}
                previewFullTruckloadFile={this.props.previewFullTruckloadFile}
            />
        </React.Fragment>
    }

    displayPOEs = () => {
        return <React.Fragment>
            <FullTruckloadPOEs
                selectedTab={this.tabLabelToTabIndex(this.state.selectedTab)}
                handleTabChange={this.handleTabChange}
                setCurrentPage={this.props.setCurrentPage}
                prevPage={this.state.prevPage}
            />
        </React.Fragment>
    }

    displayCurrentPage = (currentPage) =>{
        switch (currentPage) {
            case FTL_PAGES.SETUP:
                return this.displaySetup()
            case FTL_PAGES.CUSTOMS_BROKERS:
                return this.displayBrokers()
            case FTL_PAGES.SIGNATURES:
                return this.displaySignatures()
            case FTL_PAGES.NOA_PORTS:
                return this.displayPOEs()
        }
    }

    render(){
        return (
            <React.Fragment>
                {this.displayCurrentPage(this.state.selectedTab)}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    stateAndProvinceMapping: stateAndProvinceMappingSelector(state),
})


const actionCreators = {
}

export default withShipment({
    mapStateToProps,
    actionCreators,
}, FullTruckLoadSetting);